import { IonCard, IonCardContent, IonList, IonItem, IonToolbar, IonLabel, IonButtons, IonButton, IonSegment, IonSegmentButton, IonContent, IonChip } from '@ionic/react';
import React, { useContext, useEffect, useState } from 'react';
import Moment from 'react-moment';
import { AppContext } from '../../context/app.context';
import { getVersion } from '../../misc/phqHTTP';
import { PHQVersion, QuestionnaireModel } from '../../models/questionnaire.model';
import { QuestionnaireActionTypes } from '../../reducers/questionnaire.reducer';
import PHQRestoreAlert from './PHQRestoreAlert';
import PHQSnapShotList from './PHQSnapShotList';
import './PHQVersionList.css';


const PHQVersionList = (props: {
    fnToHideForm: (result: boolean) => void
    versions: PHQVersion[]
}) => {

    const appContext = useContext(AppContext);
    const {questionnaire, updateQuestionnaire} = appContext;
    const [alertOpen, setAlertOpen] = useState(false);
    const [versionToRestore, setVersionToRestore] = useState<PHQVersion>();
    const [segmentValue, setSegmentValue] = useState('versions');
    const isViewMode = questionnaire?.ViewMode;
    const dateTimeFormat = "YYYY/MM/DD HH:mm";

    const setViewVersion = async (version: PHQVersion) => {

        const res = await getVersion(version.PHQVersionID);
        const previewVersion = res.data.result;
        const phq = JSON.parse(previewVersion.RawPHQ) as QuestionnaireModel;
        phq.Versions = questionnaire.PhqSelected.Versions;
        const currentPHQ = questionnaire.ViewMode 
            ? JSON.parse(questionnaire.CurrentPHQ) 
            : questionnaire.PhqSelected
        
        const payload = {
            PhqSelected: phq,
            ViewMode: true,
            IsSnapShot: false,
            SnapshotID: 0,
            VersionID: version.PHQVersionID,
            CurrentPHQ: JSON.stringify(currentPHQ)
        }
        updateQuestionnaire(QuestionnaireActionTypes.UPDATE_VIEW_MODE, payload);
        setTimeout(() => {
            props.fnToHideForm(false);
        });
    }

    const selectVersionAndConfirm = (version: PHQVersion) => {
        setVersionToRestore(version);
        setAlertOpen(true);
    }
    const exitViewMode = () => {
        updateQuestionnaire(QuestionnaireActionTypes.EXIT_VIEW_MODE, null);
        props.fnToHideForm(false);
    }

    useEffect(() => {
        updateQuestionnaire(QuestionnaireActionTypes.SET_VERSIONS, props.versions);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <React.Fragment>
            <IonCard>

                <IonCardContent>
                    <IonSegment value={segmentValue} onIonChange={e => setSegmentValue(e.detail.value!)}>
                        <IonSegmentButton value="versions">
                            <IonLabel>Versions</IonLabel>
                        </IonSegmentButton>
                        <IonSegmentButton value="snapshots">
                            <IonLabel>Snapshots</IonLabel>
                        </IonSegmentButton>
                    </IonSegment>
                    <IonContent id="versionsSnapshots" scrollY={true}>
                    {segmentValue === 'versions' && (
                        <IonList>
                            <IonItem >
                                <IonToolbar>
                                    <p><strong>Version:</strong> Current</p>
                                    <IonLabel>
                                        <p><strong>Created on :</strong><Moment format={dateTimeFormat} date={new Date()} /></p>
                                    </IonLabel>
                                    <IonButtons slot="end">
                                        {isViewMode && (
                                            <IonButton size="small" fill="outline" onClick={() => { exitViewMode() }}>
                                                Restore
                                            </IonButton>
                                        )}

                                    </IonButtons>
                                </IonToolbar>
                            </IonItem>
                            {(questionnaire.PhqSelected.Versions || []).sort((a, b) => {
                                let x = new Date(a.CreatedOn).getTime(),
                                    y = new Date(b.CreatedOn).getTime();
                                return y - x
                            }).map((version, index) => {
                                return (
                                    <IonItem key={index}>
                                        <IonToolbar>
                                            <p><strong>Version:</strong> {version.Description}</p>
                                            <IonLabel>
                                                <p><strong>Created on: </strong>
                                                <Moment format={dateTimeFormat} utc local date={version.CreatedOn} /></p>
                                            </IonLabel>
                                            <IonButtons slot="end">
                                                {version.IsPublished && 
                                                    <IonChip disabled className="opacity-5" color="success">
                                                        <IonLabel>Published</IonLabel>
                                                    </IonChip>
                                                }
                                                {version.IsCurrent &&  
                                                    <IonChip disabled className="opacity-5" color="primary">
                                                        <IonLabel>Current</IonLabel>
                                                    </IonChip>
                                                }
                                                <IonButton size="small" fill="outline" onClick={() => { selectVersionAndConfirm(version) }}>
                                                    Restore
                                                </IonButton>
                                                <IonButton size="small" fill="outline" onClick={() => { setViewVersion(version) }}>
                                                    View
                                                </IonButton>
                                            </IonButtons>
                                        </IonToolbar>
                                    </IonItem>
                                )
                            })}
                        </IonList>
                    )}
                    {segmentValue === 'snapshots' && (
                        <PHQSnapShotList fnCloseModal={() => { props.fnToHideForm(false) }}></PHQSnapShotList>
                    )}
                    </IonContent>
                </IonCardContent>
            </IonCard>
            <IonButton className="ion-padding-horizontal" onClick={() => props.fnToHideForm(false)}>Close</IonButton>
            <PHQRestoreAlert version={versionToRestore} fnCloseModal={() => { setAlertOpen(false); props.fnToHideForm(false) }} snapShot={undefined} isOpen={alertOpen} />
        </React.Fragment >
    );
};
export default PHQVersionList;
